import React from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { injectIntl } from "react-intl";

const SearchFilter = (props) => {
  const { doSearch, intl, placeholder, initial } = props;
  const { formatMessage } = intl;

  const defaultPlaceholder = formatMessage({
    id: "search",
    defaultMessage: "search"
  });

  return (
    <FormGroup className="customerSearch searchFilter">
      <Label for="search">
        <i className="fas fa-search" />
      </Label>
      <Input
        type="search"
        name="search"
        id="search"
        value={initial}
        placeholder={placeholder || defaultPlaceholder}
        onChange={(e) => doSearch(e.target.value)}
      />
    </FormGroup>
  );
};

export default injectIntl(SearchFilter);
